const uxState = {
  events: [],
}

export default uxState
